/* vf-room-looks.js (T081): slider (CSS scroll-snap + arrows), pin cards, include toggles + live total, add set / add selected
   via ONE POST /cart/add.js, then Hyper's own cart drawer refresh (same calls as ProductForm in theme.js). Markup: sections/vf-room-looks.liquid */
(() => {
  if (window.vfRoomLooks) return window.vfRoomLooks.init();
  let openPin = null, busy = false, toastTimer = 0;
  const mobile = matchMedia('(max-width: 767.98px)');

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
  const fill = (t, v) => (t || '').replace(/\[(\w+)\]/g, // [n] / [price]: Liquid ends a {{ }} tag at the first "}", so the placeholders use brackets
 (m, k) => (v[k] != null ? v[k] : m));
  const track = (name, look, products) => window.vfTrack && window.vfTrack(name, { look, products });
  const url = (path) => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + path;
  const rootOf = (el) => el.closest('[data-vf-looks]');
  const slideOf = (r) => $$('.vf-look', r)[r.vfCur || 0];
  const pinsOf = (slide, i) => $$(`.vf-pin[data-i="${i}"]`, slide);

  // shop money format when a formatter exists, else "12,500 ج.م" (ar) / "EGP 12,500"; whole pounds only
  function money(r, c) {
    const f = r.dataset.moneyFormat, F = window.FoxTheme;
    let s = '';
    try {
      if (f && window.Shopify && Shopify.formatMoney) s = Shopify.formatMoney(c, f);
      else if (f && F && F.Currency) s = F.Currency.formatMoney(c, f);
    } catch (e) { s = ''; }
    if (!s) {
      const n = String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = r.dataset.lang === 'ar' ? n + ' ج.م' : 'EGP ' + n;
    }
    return s.replace(/[.,]00(?!\d)/, '');
  }

  /* ---------- set state: which rows count, total ---------- */
  function state(slide) {
    const rows = $$('.vf-row', slide), on = [], all = [];
    let sum = 0;
    rows.forEach((row, i) => {
      const ok = row.dataset.available === 'true', tick = ok && $('input', row).checked;
      if (ok) all.push(i);
      if (tick) { on.push(i); sum += +row.dataset.price; }
      row.classList.toggle('is-off', ok && !tick);
    });
    return { rows, on, all, sum };
  }

  function bar(r, st = state(slideOf(r))) {
    const b = $('[data-action="add-bar"]', r);
    b.textContent = fill(r.dataset.tSticky, { n: st.on.length, price: money(r, st.sum) });
    b.disabled = !st.on.length;
  }

  function refresh(slide) {
    const r = rootOf(slide), st = state(slide), m = $('[data-month]', slide), sel = $('[data-action="add-selected"]', slide);
    $('[data-total] bdi', slide).textContent = money(r, st.sum);
    if (m) m.textContent = fill(r.dataset.tMonth, { price: money(r, Math.ceil(st.sum / 2400) * 100 /* 24 months, as snippets/vf-look-slide.liquid */) });
    sel.textContent = fill(r.dataset.tSelected, { n: st.on.length });
    sel.disabled = !st.on.length;
    $('[data-action="add-all"]', slide).disabled = !st.all.length;
    if (slideOf(r) === slide) bar(r, st);
  }

  /* ---------- slider ---------- */
  function setup(r) {
    const tr = $('[data-track]', r), slides = $$('.vf-look', tr), arrows = $$('.vf-looks__arrow', r);
    const count = $('[data-count]', r), prog = $('[data-fill]', r), rtl = getComputedStyle(tr).direction === 'rtl';
    let ticking = false;
    r.classList.toggle('is-rtl', rtl);
    r.vfCur = -1;

    const sync = () => {
      const tl = tr.getBoundingClientRect().left, d = slides.map((s) => Math.abs(s.getBoundingClientRect().left - tl));
      const best = d.indexOf(Math.min(...d));
      ticking = false;
      if (best === r.vfCur) return;
      closeCard();
      r.vfCur = best;
      if (count) count.textContent = `${best + 1} / ${slides.length}`;
      if (prog) prog.style.transform = `translateX(${(rtl ? -best : best) * 100}%)`;
      if (arrows.length) { arrows[0].disabled = best === 0; arrows[1].disabled = best === slides.length - 1; }
      bar(r);
      if (r.vfFlag) r.vfFlag();
    };
    // arrows sit on the photo's two side edges (owner: header arrows read as belonging to the section above); every slide has the
    // same layout, so the photo's place inside a snapped slide gives the spot: container-relative, unaffected by the scroll offset
    const box = $('.vf-looks__container', r);
    const place = () => {
      const s = slides[Math.max(r.vfCur, 0)], ph = s && $('.vf-look__photo', s);
      if (!ph || arrows.length < 2) return;
      const c = box.getBoundingClientRect(), t = tr.getBoundingClientRect(), sr = s.getBoundingClientRect(), p = ph.getBoundingClientRect();
      const x = t.left + (p.left - sr.left) - c.left, y = p.top - c.top + p.height / 2, w = arrows[0].offsetWidth || 44, pad = 12;
      let startX = rtl ? x + p.width - pad - w : x + pad, endX = rtl ? x + pad : x + p.width - pad - w;
      if (!mobile.matches) { // desktop (owner): outside the look, centred in the track's side margins, so the photo keeps only its pins
        const gl = t.left - c.left, gr = c.right - t.right, L = Math.max(0, (gl - w) / 2), R = t.right - c.left + Math.max(0, (gr - w) / 2);
        startX = rtl ? R : L;
        endX = rtl ? L : R;
      }
      arrows[0].style.left = startX + 'px';
      arrows[1].style.left = endX + 'px';
      arrows.forEach((a) => { a.style.top = y + 'px'; });
      r.classList.add('is-arrows-on-photo');
    };
    if (window.ResizeObserver) new ResizeObserver(place).observe(box);
    place();
    tr.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
    arrows.forEach((a) => a.addEventListener('click', () => {
      const to = slides[clamp(r.vfCur + +a.dataset.dir, 0, slides.length - 1)];
      tr.scrollBy({ left: to.getBoundingClientRect().left - tr.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
    sync();

    if (!window.IntersectionObserver) return;
    const viewIo = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      viewIo.unobserve(e.target);
      track('look_view', e.target.dataset.look, e.target.dataset.handles.split(','));
    }), { threshold: 0.5 });
    slides.forEach((s) => viewIo.observe(s));
    // sticky bar: on while the section is mid-screen, but not while this look's own buttons are visible
    const flag = { sec: false }, sticky = $('[data-sticky]', r);
    r.vfFlag = () => sticky.classList.toggle('is-on', flag.sec && !slideOf(r).vfActOn);
    new IntersectionObserver((es) => { flag.sec = es[0].isIntersecting; r.vfFlag(); }, { rootMargin: '-35% 0px -35% 0px' }).observe(r);
    const actIo = new IntersectionObserver((es) => {
      es.forEach((e) => { e.target.closest('.vf-look').vfActOn = e.isIntersecting; });
      r.vfFlag();
    }, { threshold: 0.6 });
    $$('.vf-look__actions', r).forEach((a) => actIo.observe(a));
  }

  /* ---------- pin card: opens beside the pin, flips side (or above/below) near the photo edges ---------- */
  function closeCard(refocus) {
    if (!openPin) return;
    openPin.pin.classList.remove('is-open');
    openPin.pin.setAttribute('aria-expanded', 'false');
    openPin.card.classList.remove('is-open');
    if (refocus) openPin.pin.focus();
    openPin = null;
  }

  function openCard(pin, byKey) {
    const slide = pin.closest('.vf-look'), pr = pin.closest('.vf-look__photo').getBoundingClientRect();
    const card = $(`.vf-card[data-i="${pin.dataset.i}"]`, slide), b = pin.getBoundingClientRect();
    closeCard();
    card.classList.add('is-open');
    const cx = b.left - pr.left + b.width / 2, cy = b.top - pr.top + b.height / 2;
    const w = card.offsetWidth, h = card.offsetHeight, gap = 22, m = 6;
    const pins = $$('.vf-pin', slide).filter((p) => p.offsetParent).map((p) => {
      const q = p.getBoundingClientRect();
      return [q.left - pr.left + q.width / 2, q.top - pr.top + q.height / 2, p === pin ? 99 : 1];
    });
    // four candidate places (right, left, below, above), clamped into the photo; fewest pins covered (its own counts most), then the least shift
    const best = [[cx + gap, cy - h / 2], [cx - gap - w, cy - h / 2], [cx - w / 2, cy + gap], [cx - w / 2, cy - gap - h]].map(([px, py]) => {
      const x = clamp(px, m, pr.width - w - m), y = clamp(py, m, pr.height - h - m);
      const hits = pins.reduce((n, [ox, oy, k]) => n + (ox > x - 14 && ox < x + w + 14 && oy > y - 14 && oy < y + h + 14 ? k : 0), 0);
      return { x, y, score: hits * 1e4 + Math.abs(x - px) + Math.abs(y - py) };
    }).sort((a, b) => a.score - b.score)[0];
    card.style.left = best.x + 'px';
    card.style.top = best.y + 'px';
    pin.classList.add('is-open');
    pin.setAttribute('aria-expanded', 'true');
    openPin = { pin, card };
    if (byKey) ($('.vf-card__add:not(:disabled), .vf-card__title', card) || card).focus();
    track('look_pin_open', slide.dataset.look, [$$('.vf-row', slide)[pin.dataset.i].dataset.handle]);
  }

  /* ---------- cart ---------- */
  async function post(items) {
    const sec = [], body = { items };
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sec } }));
    if (sec.length) { body.sections = sec.join(','); body.sections_url = location.pathname; }
    const res = await fetch(url('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const j = await res.json();
    return { ok: res.ok && !j.status, code: res.status, body: j };
  }

  async function showCart(added, trigger) {
    const F = window.FoxTheme;
    if (F && F.settings && F.settings.cartType === 'page') { location.href = url('cart'); return; }
    if (!(F && F.routes && F.pubsub && F.utils)) return;
    const cart = await (await fetch(F.routes.cart_url, F.utils.fetchConfig())).json();
    cart.sections = added.sections;
    F.pubsub.publish(F.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
    document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: added } }));
    const d = $('cart-drawer');
    if (d && d.show) d.show(trigger);
  }

  function toast(r, text, warn) {
    const t = $('[data-toast]', r);
    t.textContent = text;
    t.classList.toggle('is-warn', !!warn);
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-on'), 3800);
  }

  async function add(btn, slide, idx, evName) {
    const r = rootOf(slide), st = state(slide), items = idx.map((i) => ({ id: +st.rows[i].dataset.variantId, quantity: 1 }));
    if (!items.length || busy) return;
    busy = true;
    const locked = $$('.vf-btn:not(:disabled)', r), label = btn.textContent;
    let failed = 0, last = null;
    locked.forEach((b) => { b.disabled = true; });
    btn.classList.add('is-busy');
    btn.textContent = r.dataset.tAdding;
    track(evName, slide.dataset.look, idx.map((i) => st.rows[i].dataset.handle));
    try {
      const res = await post(items);
      if (res.ok) last = res.body;
      else if (res.code !== 422) throw new Error('cart ' + res.code);
      else if (items.length === 1) failed = 1;
      else {
        // one line is unavailable and the whole request was refused: add the lines one by one
        for (const it of items) {
          const one = await post([it]);
          if (one.ok) last = one.body; else failed++;
        }
      }
      if (failed) toast(r, failed === 1 ? r.dataset.tUnavailable : fill(r.dataset.tUnavailableN, { n: failed }), true);
      else toast(r, r.dataset.tAdded);
      if (last) await showCart(last, btn);
    } catch (e) {
      toast(r, r.dataset.tError, true);
    }
    busy = false;
    btn.classList.remove('is-busy');
    btn.textContent = label;
    locked.forEach((b) => { b.disabled = false; });
    closeCard();
    refresh(slide);
  }

  function act(btn) {
    const a = btn.dataset.action, r = rootOf(btn);
    if (a === 'close') return closeCard(true);
    if (btn.disabled || busy) return;
    const slide = a === 'add-bar' ? slideOf(r) : btn.closest('.vf-look'), st = state(slide);
    if (a === 'add-all') add(btn, slide, st.all, 'look_add_set');
    else if (a === 'add-one') add(btn, slide, [+btn.dataset.i], 'look_add_selected');
    else add(btn, slide, st.on, a === 'add-bar' && st.on.length === st.all.length ? 'look_add_set' : 'look_add_selected');
  }

  /* ---------- events (delegated, registered once) ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target, pin = t.closest('.vf-pin'), btn = t.closest('[data-vf-looks] [data-action]'), link = t.closest('.vf-row__link');
    if (pin) { if (openPin && openPin.pin === pin) closeCard(); else openCard(pin, e.detail === 0); return; }
    if (btn) return act(btn);
    if (link && mobile.matches) {
      const p = pinsOf(link.closest('.vf-look'), link.closest('.vf-row').dataset.i).find((x) => x.offsetParent);
      if (p) { e.preventDefault(); return openCard(p); }
    }
    if (openPin && !t.closest('.vf-card')) closeCard();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openPin) closeCard(true); });
  document.addEventListener('change', (e) => { if (e.target.classList.contains('vf-row__box')) refresh(e.target.closest('.vf-look')); });
  ['mouseover', 'mouseout'].forEach((type) => document.addEventListener(type, (e) => {
    const row = e.target.closest('.vf-row');
    if (!row) return;
    row.classList.toggle('is-hot', type === 'mouseover');
    pinsOf(row.closest('.vf-look'), row.dataset.i).forEach((p) => p.classList.toggle('is-hot', type === 'mouseover'));
  }));
  let vw = innerWidth;
  addEventListener('resize', () => { if (innerWidth !== vw) { vw = innerWidth; closeCard(); } }); // not on the URL bar showing/hiding

  function init() {
    $$('[data-vf-looks]').forEach((r) => {
      if (r.vfReady) return;
      r.vfReady = true;
      setup(r);
      $$('.vf-look', r).forEach(refresh);
    });
  }
  window.vfRoomLooks = { init };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', (e) => { // theme editor: selecting a look shows its slide
    const s = e.target.closest('.vf-look'), tr = s && $('[data-track]', rootOf(s));
    if (tr) tr.scrollBy({ left: s.getBoundingClientRect().left - tr.getBoundingClientRect().left });
  });
  init();
})();
